import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { isPresent } from './lang';

// export class CustomValidators {
/**
 * Validator that requires controls to have a value of a range length.
 */
export function rangeLength(data: Array<number>): ValidatorFn {
  return (
    control: AbstractControl
  ): {
    [key: string]: any;
  } => {
    if (isPresent(Validators.required(control)) || !data) {
      return null;
    }

    const v: string = control.value;
    return v.toString().length >= data[0] &&
      v.toString().length <= data[1]
      ? null
      : {
          errorMessage: 'Entered value length should be with in the range',
          rangeLength: true
        };
  };
}

/**
 * Validator that requires controls to have a value of a min value.
 */
export function min(minVal: number): ValidatorFn {
  return (
    control: AbstractControl
  ): {
    [key: string]: any;
  } => {
    if (isPresent(Validators.required(control)) || !minVal) {
      return null;
    }

    const v: number = control.value;
    return v >= minVal
      ? null
      : {
          errorMessage: 'Entered value should be greater than min value',
          min: true
        };
  };
}

/**
 * Validator that requires controls to have a value of a max value.
 */
export function max(maxVal: number): ValidatorFn {
  return (
    control: FormControl
  ): {
    [key: string]: any;
  } => {
    if (isPresent(Validators.required(control)) || !maxVal) {
      return null;
    }

    const v: number = control.value;
    return v <= maxVal
      ? null
      : {
          errorMessage: 'Entered value should be less than max value',
          max: true
        };
  };
}

export function decimal(value: number): ValidatorFn {
  return ( control: FormControl): {
    [key: string]: any;
  } => {
    if (isPresent(Validators.required(control)) || !value) {
      return null;
    }

    const v: number = control.value;
    let length = 0;
    if (v.toString().split('.')[1]) {
      length = v.toString().split('.')[1].length || 0;
    }
    return length <= value
      ? null
      : {
          errorMessage: 'Entered value can have maximum ' + value + ' decimal places',
          decimal: true
        };
  };
}

/**
 * Validator that requires controls to have a value of a range value.
 */
export function range(value: Array<number>): ValidatorFn {
  return (
    control: AbstractControl
  ): {
    [key: string]: any;
  } => {
    if (isPresent(Validators.required(control)) || !value) {
      return null;
    }
    let errorMessage = '';
    const v: number = control.value;
    if (v < value[0]) {
      errorMessage = 'Entered value should be greater than minimum';
    } else if (v > value[1]) {
      errorMessage = 'Entered value should be less than maximum';
    }
    return v >= value[0] && v <= value[1]
      ? null
      : {
          errorMessage,
          range: true
        };
  };
}

/**
 * Validator that requires controls to have a value of digits.
 */
export function digits(control: AbstractControl): any {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value;
  return /^\d+$/.test(v)
    ? null
    : {
        errorMessage: 'Entered value should have digits only',
        digits: true
      };
}

/**
 * Validator that requires controls to have a value of number.
 */
export function number(control: AbstractControl): any {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value;
  return /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(v)
    ? null
    : {
        errorMessage: 'The value should be a number.',
        number: true
      };
}
// }
